import { render, staticRenderFns } from "./BindingAccount.vue?vue&type=template&id=048aa866&scoped=true"
import script from "./BindingAccount.vue?vue&type=script&lang=js"
export * from "./BindingAccount.vue?vue&type=script&lang=js"
import style0 from "./BindingAccount.vue?vue&type=style&index=0&id=048aa866&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048aa866",
  null
  
)

export default component.exports